module.exports = __webpack_public_path__ + "static/media/signup-img.6b26fe24.svg";